<template>
  <section>
    <top-alternative-section :image="PuntoVentaImage" :title="$t('punto-de-venta.topAlternative.title')"
      :content="$t('punto-de-venta.topAlternative.content')"></top-alternative-section>

    <features-section :title="$t('punto-de-venta.features.title')" :description="$t('punto-de-venta.features.description')" 
      :items="$t('punto-de-venta.features.items')" ></features-section>

    <contact-section></contact-section>
  </section>
</template>

<script>
import TopAlternativeSection from "../sections/TopAlternativeSection.vue";
import PuntoVentaImage from "../../assets/punto-venta.jpg";
import FeaturesSection from "../sections/FeaturesSection.vue";
import ContactSection from "../sections/ContactSection.vue";

export default {
  components: {
    TopAlternativeSection,
    FeaturesSection,
    ContactSection
  },
  data() {
    return {
      PuntoVentaImage: PuntoVentaImage,
    };
  },
  metaInfo: {
    title: 'Punto de venta',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Aumenta tus ventas con un punto de venta omnicanal a través de canales físicos y digitales, centraliza tus cobros, factura, concilia y emite carta porte para traslado y entrega de mercancía; todo en una misma aplicación.' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  }
};
</script>
